

import React, { useState } from 'react';
import './HongButton.scss';

// const HongButton = ({
//   children,
//   onClick,
//   className = '',
//   disableTime = 0,
//   startIcon, // 아이콘을 위한 prop 추가
//   ...rest
// }) => {
//   const [ripples, setRipples] = useState([]);
//   const [isDisabled, setIsDisabled] = useState(false);
//   const [timer, setTimer] = useState(0);

//   const createRipple = (event) => {
//     const button = event.currentTarget;
//     const rippleContainer = button.getBoundingClientRect();
//     const size = Math.max(rippleContainer.width, rippleContainer.height);
//     const x = event.clientX - rippleContainer.left - size / 2;
//     const y = event.clientY - rippleContainer.top - size / 2;

//     const newRipple = {
//       key: new Date().getTime(),
//       style: {
//         width: size,
//         height: size,
//         top: y,
//         left: x,
//       },
//     };

//     setRipples((prevRipples) => [...prevRipples, newRipple]);

//     setTimeout(() => {
//       setRipples((prevRipples) =>
//         prevRipples.filter((ripple) => ripple.key !== newRipple.key)
//       );
//     }, 600);
//   };

//   const handleMouseDown = (e) => {
//     if (isDisabled) return;
//     createRipple(e);

//     if (onClick) {
//       onClick(e);
//     }

//     if (disableTime > 0) {
//       setIsDisabled(true);
//       setTimer(disableTime);

//       const countdown = setInterval(() => {
//         setTimer((prev) => {
//           if (prev <= 1) {
//             clearInterval(countdown);
//             setIsDisabled(false);
//             return 0;
//           }
//           return prev - 1;
//         });
//       }, 1000);
//     }
//   };

//   return (
//     <button
//       className={`hong-button ${className} ${isDisabled ? 'disabled' : ''}`}
//       onMouseDown={handleMouseDown}
//       disabled={isDisabled}
//       {...rest}
//     >
//       {ripples.map((ripple) => (
//         <span key={ripple.key} className="ripple" style={ripple.style} />
//       ))}
//       {/* 아이콘과 텍스트를 함께 렌더링 */}
//       {isDisabled && disableTime > 0 ? (
//         `다시시도 (${timer})`
//       ) : (
//         <>
//           {startIcon && <span className="start-icon">{startIcon}</span>}
//           {children}
//         </>
//       )}
//     </button>
//   );
// };

const HongButton = ({
  children,
  onClick,
  className = '',
  disableTime = 0,
  startIcon,
  disabled = false, // 외부에서 전달된 disabled prop
  ...rest
}) => {
  const [ripples, setRipples] = useState([]);
  const [isDisabled, setIsDisabled] = useState(false);
  const [timer, setTimer] = useState(0);

  const createRipple = (event) => {
    const button = event.currentTarget;
    const rippleContainer = button.getBoundingClientRect();
    const size = Math.max(rippleContainer.width, rippleContainer.height);
    const x = event.clientX - rippleContainer.left - size / 2;
    const y = event.clientY - rippleContainer.top - size / 2;

    const newRipple = {
      key: new Date().getTime(),
      style: {
        width: size,
        height: size,
        top: y,
        left: x,
      },
    };

    setRipples((prevRipples) => [...prevRipples, newRipple]);

    setTimeout(() => {
      setRipples((prevRipples) =>
        prevRipples.filter((ripple) => ripple.key !== newRipple.key)
      );
    }, 600);
  };

  const handleMouseDown = (e) => {
    if (disabled || isDisabled) return;

    createRipple(e);

    if (onClick) {
      onClick(e);
    }

    if (disableTime > 0) {
      setIsDisabled(true);
      setTimer(disableTime);

      const countdown = setInterval(() => {
        setTimer((prev) => {
          if (prev <= 1) {
            clearInterval(countdown);
            setIsDisabled(false);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }
  };

  return (
    <button
      className={`hong-button ${className} ${(disabled || isDisabled) ? 'disabled' : ''}`}
      onMouseDown={handleMouseDown}
      disabled={disabled || isDisabled}
      {...rest}
    >
      {ripples.map((ripple) => (
        <span key={ripple.key} className="ripple" style={ripple.style} />
      ))}
      {isDisabled && disableTime > 0 ? (
        `다시시도 (${timer})`
      ) : (
        <>
          {startIcon && <span className="start-icon">{startIcon}</span>}
          {children}
        </>
      )}
    </button>
  );
};


export default HongButton;

//2025-05-16 disable 추가